<template>
    <ul class="omni-sidebar omni-sidebar-root">
        <OmniSidebarItem
            v-for="(item, index) in items"
            :key="index"
            :item="item"
        />
    </ul>
</template>

<style lang="scss">
    .omni-sidebar {
        list-style: none;
        padding: 0;
        margin: 0;
    }
</style>

<script>
import OmniSidebarItem from './OmniSidebarItem.vue';

export default {
    name: "OmniSidebar",

    components: {
        OmniSidebarItem,
    },
    
    props: {
        items: {
            type: Object,
            required: true,
            default: {},
        },
    },
}
</script>
